import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import 'chart.js/auto';
import { useState } from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';
import { Button, Row, Col } from 'react-bootstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FaSortAlphaDown, FaSortAlphaUp } from 'react-icons/fa';
import { FaSortNumericDown, FaSortNumericUp } from 'react-icons/fa';


ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
// components/Admin/Sondaggi/Risposte/DomandaRisposteGrafico.js
const defaultColors = [
    '#3366CC', '#DC3912', '#FF9900', '#109618', '#990099',
    '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E',
    '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC',
    '#E67300', '#8B0707', '#651067', '#329262', '#5574A6',
    '#3B3EAC'
  ];


  
  const prepareChartData = (domanda, risposte) => {
    const opzioni = domanda.opzioniRisposte || [];
    const risposteDomanda = risposte.filter(r => r.domandaId === domanda.domId);
  
    const counts = opzioni.map(
      o => risposteDomanda.filter(r => r.opzioneRispostaId === o.opzRisId).length
    );
    const labels = opzioni.map(o => o.opzRisTesto);
  
    // Crea un array di colori corrispondente, gestendo il caso di più opzioni che colori
    const backgroundColors = labels.map((_, index) => defaultColors[index % defaultColors.length]);
  
    return {
      labels: labels,
      datasets: [{
          label: 'Risposte',
          data: counts,
          backgroundColor: backgroundColors, // Usa l'array di colori generato
          borderWidth: 1,
      }],
    };
  };
  export default function DomandaGraficoPdfContent({ domanda, risposte }) {
    const chartData = prepareChartData(domanda, risposte);
    const hasResponses = chartData.datasets[0].data.some(count => count > 0);
  
    // Opzioni per il grafico Doughnut
    const options = {
      responsive: true,
      maintainAspectRatio: false, // Permette al grafico di adattarsi meglio allo spazio ridotto
      plugins: {
        legend: {
          display: false // Legenda standard nascosta
        },
        tooltip: {
           enabled: true
        },
        datalabels: {
          display: true,
          color: '#fff',
          font: {
            weight: 'bold',
            size: 10 // Riduci dimensione font per grafico più piccolo
          },
          formatter: (value, context) => {
             const visibleData = context.chart.data.datasets[0].data.filter(v => v > 0);
             const total = visibleData.reduce((a, b) => a + b, 0);
             if (value === 0 || total === 0) return '';
             const percentage = ((value / total) * 100).toFixed(0) + '%';
             return percentage;
          },
          // Potresti voler nascondere etichette troppo piccole
          // display: context => {
          //    const value = context.dataset.data[context.dataIndex];
          //    const total = context.chart._metasets[context.datasetIndex].total;
          //    return total > 0 ? (value / total * 100) > 3 : false; // Mostra solo se > 3%
          // }
        }
      }
    };
  
    // Calcola il totale per le percentuali nella legenda personalizzata
    const totalResponses = chartData.datasets[0].data.reduce((sum, count) => sum + count, 0);
  
    return (
      <div className="mb-4 p-3 bg-white pdf-capture-content">
        {/* Testo della domanda */}
        <h6 className="mb-1 fw-bold">
          Domanda {domanda.domNumPosizione} - {domanda.domDomanda}
        </h6>
        <small className="text-muted d-block mb-3">
          {domanda.tipoDomanda?.tipDomMultipla ? "Scelta multipla" : "Scelta singola"}
        </small>
  
        {/* Contenitore Flex per Grafico e Legenda */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}> {/* Usa Flexbox */}
  
          {/* Colonna Sinistra: Grafico */}
          <div style={{ flex: '0 0 180px', height: '180px' }}> {/* Larghezza e altezza fisse per il grafico */}
             {hasResponses ? (
                 <Doughnut data={chartData} options={options} plugins={[ChartDataLabels]} />
             ) : (
                 <div className="d-flex justify-content-center align-items-center h-100">
                   <p className="text-center text-muted fst-italic m-0">Nessuna risposta.</p>
                 </div>
             )}
          </div>
  
          {/* Colonna Destra: Legenda Personalizzata */}
          <div style={{ flex: 1 }}> {/* Occupa lo spazio rimanente */}
            {hasResponses ? (
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '10px' }}> {/* Riduci font-size */}
                {chartData.labels.map((label, index) => {
                  const count = chartData.datasets[0].data[index];
                  const percentage = totalResponses > 0 ? ((count / totalResponses) * 100).toFixed(1) : 0;
                  const color = chartData.datasets[0].backgroundColor[index];
  
                  // Non mostrare elementi con 0 risposte nella legenda? (Opzionale)
                  // if (count === 0) return null;
  
                  return (
                    <li key={index} style={{ marginBottom: '4px', display: 'flex', alignItems: 'center' }}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '10px', // Dimensione indicatore colore
                          height: '10px',
                          backgroundColor: color,
                          marginRight: '8px',
                          borderRadius: '2px', // Quadrato o '50%' per cerchio
                          flexShrink: 0 // Impedisce al quadratino di restringersi
                        }}
                      ></span>
                      <span style={{ flexGrow: 1, marginRight: '8px' }}>{label}</span>
                      <strong style={{ flexShrink: 0 }}>{count} ({percentage}%)</strong>
                    </li>
                  );
                })}
              </ul>
            ) : (
              // Puoi mettere un messaggio anche qui se non ci sono risposte
              null
            )}
          </div>
  
        </div> {/* Fine contenitore Flex */}
      </div>
    );
  }